module.exports = __webpack_public_path__ + "static/img/job_5.10178d33.png";